export default {
    state: {
        data: {},
        date: null,
        dataClass: {},
        periodId: null
    },
    getters: {
        getDataNote(state) {
            return state.data;
        },
        getDate(state) {
            return state.date;
        },
        getdataClass(state) {
            return state.dataClass
        },
        getPeriodId: state => state.periodId,
    },
    mutations: {
        SET_DATA(state, payload) {
            state.data = payload;
        },
        SET_DATE(state, payload) {
            state.date = payload;
        },
        SET_DATA_CLASS(state, payload) {
            state.dataClass = payload;
        },
        SET_PERIOD_ID(state, payload) {
            state.periodId = payload;
        },
    },
};
